module.exports = __webpack_public_path__ + "08_face.6940179e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer1/08_face.png
// module id = VIvb
// module chunks = 0